import React from 'react';

import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import StarRating from '../../../../components/shared/StarRating';
import SelectDropdown from '../../../../components/forms/SelectDropdown';
import { activities } from '../../../../utils/activity_util';
import { wrapEventHandler } from '../../../../utils/handlers';

const createReactClass = require('create-react-class');

const TrackUploadForm = createReactClass({
  getInitialState() {
    return { rating: 0, smoothGPX: this.props.offerSmoothOption, selectedActivity: activities[5] };
  },
  setRating(event, rating) {
    this.setState({ rating });
  },
  handleUploadClick() {
    // If press Upload with no files, show file selection dialog
    if (this.dz.files.length == 0) {
      $('.fileupload-drop.dz-clickable').click();
      return false;
    }
    if (this.props.addHiddenNameField) {
      const mapName = prompt(StringConstantsMixin.strings.TRACK_DETAIL.ENTER_NAME);
      if (mapName.trim() !== '') {
        $('input#hidden-name-field').val(mapName);
      }
    }
    this.dz.processQueue();
    return false;
  },
  handleSelectChange(e) {
    const selectedActivity = activities.find(activity => activity.value === e.currentTarget.dataset.value);
    this.setState({ selectedActivity });
  },
  handleCancelClick() {
    this.props.onCancelClick();
    if (this.dz && this.refs) {
      this.dz.removeAllFiles();
      this.refs.uploadForm.reset();
      this.setRating(null, 0);
    }
    return false;
  },
  handleSmoothChange() {
    this.setState({ smoothGPX: !this.state.smoothGPX });
  },
  handleUploadSuccess(newData) {
    if (newData && newData.maps && !this.props.routesOnly) {
      this.handleCancelClick();
      this.props.uploadSuccess(newData, 'tracks');
    } else if (this.props.routesOnly) {
      this.props.uploadSuccess(newData, 'routes');
    }
  },
  handleUploadError(error) {
    const errorMessage = error.errors && error.errors[0] ? error.errors[0].message : StringConstantsMixin.strings.UPLOAD_ERROR;
    $('.fileupload-form-input .dz-error-message').text(errorMessage);
  },
  componentDidMount() {
    this.dz = AT.Shared.DropzoneUpload.init({
      formParam: '#track-fileupload',
      url: this.props.url,
      paramName: 'file',
      previewDiv: '.track-preview',
      removeFileText: StringConstantsMixin.strings.CONVERTER.REMOVE_FILE,
      maxFiles: 1,
      validExtensions: this.props.validExtensions,
      successCallback: this.handleUploadSuccess,
      errorCallback: this.handleUploadError
    });
  },
  componentWillUnmount() {
    this.dz.destroy();
    this.dz = null;
  },
  render() {
    let trailIdField;
    if (this.props.trailId) {
      trailIdField = <input type="hidden" name="trail_id" value={this.props.trailId} />;
    }

    let smoothRoutesField = null;
    if (this.props.offerSmoothOption) {
      smoothRoutesField = (
        <div className="show-title gpx-smooth">
          <input id="show-smooth-flag" name="smooth" type="checkbox" checked={this.state.smoothGPX} onChange={this.handleSmoothChange} />
          <label htmlFor="show-smooth-flag">{StringConstantsMixin.strings.SMOOTH_FILE}</label>
        </div>
      );
    }
    const cssClass = this.props.formVisible ? '' : 'hidden';
    let attributeFields = null;
    let systemOwnedField = null;
    let hiddenNameField = null;
    if (this.props.systemOwned) {
      systemOwnedField = <input type="hidden" name="system_owned" value="true" />;
    } else if (this.props.addHiddenNameField) {
      hiddenNameField = <input id="hidden-name-field" type="hidden" name="name" value="" />;
    } else if (this.props.showExtraFields) {
      attributeFields = (
        <div>
          <label>{StringConstantsMixin.strings.RECORDING_NAME}</label>
          <br />
          <input type="text" className="text" name="name" placeholder={StringConstantsMixin.strings.ADD_A_CAPTION} />
          <br />
          <label>{StringConstantsMixin.strings.NOTES}</label>
          <br />
          <textarea className="text" rows="5" name="description" placeholder={StringConstantsMixin.strings.KEEP_NOTES} />
          <br />
          <div className="input activity optional">
            <label>{StringConstantsMixin.strings.WHAT_WERE_YOU_DOING}</label>
            <div>
              <SelectDropdown name="activity" options={activities} handleChange={this.handleSelectChange} defaultItem={this.state.selectedActivity} />
            </div>
          </div>
          <br />
          <label>{StringConstantsMixin.strings.HOW_WAS_IT}</label>
          <br />
          <div>
            <StarRating config={this.state.rating} handler={this.setRating} />
          </div>
        </div>
      );
    }
    const uploadText = this.props.uploadText ? this.props.uploadText : StringConstantsMixin.strings.TRACK_DETAIL.GPX_UPLOAD_TEXT;

    let hiddenCreateAsMapField = null;
    if (this.props.createAsMap) {
      hiddenCreateAsMapField = <input type="hidden" name="create_as_map" value="true" />;
    }

    return (
      <div id="track-fileupload-container" className={cssClass}>
        <form id="track-fileupload" ref="uploadForm">
          <div className="form-content">
            <div className="fileupload-form-input">
              <div className="fileupload-drop dz-clickable dz-message">{uploadText}</div>
              <div className="dropzone-previews track-preview" />
            </div>
            <input type="hidden" name="presentation_type" value="track" />
            {trailIdField}
            {systemOwnedField}
            {hiddenNameField}
            {hiddenCreateAsMapField}
            {attributeFields}
            {smoothRoutesField}
            <div id="track-fileupload-submit" className="fileupload-buttonbar">
              <button className="upload btn green simple upload-form-btn" onClick={wrapEventHandler(this.handleUploadClick)}>
                <span data-test-id="Upload">{StringConstantsMixin.strings.UPLOAD}</span>
              </button>
              <button id="track-fileupload-reset" className="cancel btn upload-form-btn simple" onClick={wrapEventHandler(this.handleCancelClick)}>
                <span>{StringConstantsMixin.strings.CANCEL}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
});

TrackUploadForm.defaultProps = {
  showExtraFields: true,
  addHiddenNameField: false,
  url: '/api/alltrails/maps/gpx',
  routesOnly: false,
  createAsMap: false,
  validExtensions: null, // Default to allowing everything
  offerSmoothOption: false
};

export { TrackUploadForm };
